import React from 'react';
import LegalPage from './LegalPage';

const TermsOfService = () => {
  return (
    <LegalPage title="Terms of Service">
      <p>Last updated: April 30, 2026</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>1. Agreement to Terms</h2>
      <p>By accessing or using our platform, you agree to be bound by these Terms of Service.</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>2. Intellectual Property Rights</h2>
      <p>Unless otherwise indicated, the platform is our proprietary property and all source code, databases, functionality, software, and website designs are owned or controlled by us.</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>3. User Representations</h2>
      <p>By using the platform, you represent and warrant that all registration information you submit will be true, accurate, current, and complete.</p>

      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>4. Prohibited Activities</h2>
      <p>You may not access or use the platform for any purpose other than that for which we make the platform available.</p>
    </LegalPage>
  );
};

export default TermsOfService;
